import {Backdrop, Box, alpha} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import DropZone from './Uploads/DropZone.jsx';

const FileDrop = ({isDragging, onDragLeave, onDrop}) => {
  return (
    <Backdrop
      open={isDragging}
      onDragLeave={onDragLeave}
      sx={{
        color: 'common.white',
        zIndex: 'modal',
        backgroundColor: theme => alpha(theme.palette.grey[900], 0.75),
      }}
      className="pl-mode-dark"
    >
      <Box sx={{width: '100%', height: '100%', display: 'flex'}}>
        <DropZone
          sx={{
            backgroundColor: 'transparent',
          }}
          onDrop={onDrop}
        />
      </Box>
    </Backdrop>
  );
};

FileDrop.propTypes = {
  isDragging: PropTypes.bool,
  onDragLeave: PropTypes.func,
  onDrop: PropTypes.func,
};

export default FileDrop;
